import axios from "axios";
import axiosRetry from "axios-retry";
import * as msTeams from "@microsoft/teams-js";

const defaultAxiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    withCredentials: true,
});

axiosRetry(defaultAxiosClient, {
    retries: 1,
    retryCondition: async (error) => {
        const shallRetry = error?.response?.status === 401;

        if (shallRetry) {
            const apiAccessToken = await msTeams.authentication.getAuthToken();

            await defaultAxiosClient.post(
                "/public/auth",
                {},
                {
                    headers: {
                        authorization: apiAccessToken,
                        "content-type": "application/json;charset=UTF-8",
                    },
                }
            );
        }

        return shallRetry;
    },
});

export default defaultAxiosClient;
